function getEvidenceForDetectionType(evidence, detectionType, eventIdsByType = {}) {
  const evidenceList = Array.isArray(evidence) ? evidence : [];

  if (evidenceList.length === 0) {
    return [];
  }

  if (!detectionType) {
    return evidenceList;
  }

  const typeEventIds = new Set(eventIdsByType[detectionType] || []);

  return evidenceList.filter((item) => (
    item.triggerReason === detectionType
      || (item.detectionEventId && typeEventIds.has(item.detectionEventId))
  ));
}

function getVisualEvidenceCount(evidence, detectionType, eventIdsByType = {}) {
  return getEvidenceForDetectionType(evidence, detectionType, eventIdsByType)
    .filter((item) => item.type !== 'popup_response').length;
}

function getEvidenceUrlKey(evidenceItem = {}) {
  return evidenceItem.filePath || evidenceItem.fileName || '';
}

export {
  getEvidenceForDetectionType,
  getVisualEvidenceCount,
  getEvidenceUrlKey,
};
